import { ITranslationEntry } from '../lang';

export const ES: ITranslationEntry = {
  translations: {
    notifications: 'Notificaciones',
    markAllAsRead: 'marcar todo como leído',
    poweredBy: 'Con tecnología de',
    settings: 'Configuración',
  },
  lang: 'es',
};
